import React from "react";

// Components
import { IonPage } from "@ionic/react";
import Header from "../Header/Header";

// Styles
import "./BasicTemplate.scss";

const BasicTemplate = (props: any) => {
  return (
    <IonPage className={`basic-template ${props.className}`}>
      {!props.hideHeader && (
        <Header hideBackButton={props.hideBackButton} backButtonLink={props.backButtonLink} backButtonOnClick={props.backButtonOnClick} hideHamburger={props.hideHamburger} title={props.title} />
      )}
      {props.children}
    </IonPage>
  );
};

export default BasicTemplate;
